import React from "react";

/**
 * AQ Assist brand mark — AscensionQ short logo.
 * Pass `bordered` for a clean light border around the logo chip.
 */
export default function FaqAssistMark({ className = "", bordered = false }) {
  return (
    <span
      className={`faq-assist-mark${bordered ? " faq-assist-mark--bordered" : ""}${
        className ? ` ${className}` : ""
      }`}
      aria-hidden="true"
    >
      <img src="/logo.png" alt="" className="faq-assist-mark__logo" />
    </span>
  );
}

/**
 * Magic wand + popping stars — place after the “AQ Assist” label.
 */
export function FaqAssistAiIcon({ className = "" }) {
  return (
    <span
      className={`faq-assist-ai${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <i className="fas fa-wand-magic-sparkles" />
      <span className="faq-assist-ai__star faq-assist-ai__star--1" />
      <span className="faq-assist-ai__star faq-assist-ai__star--2" />
      <span className="faq-assist-ai__star faq-assist-ai__star--3" />
    </span>
  );
}
